/**
 * @memberof data-references
 * @classdesc
 * Overrides a single variables display properties; from inclusion, to format and labeling.
 *
 * @property {string} [label]
 * @property {string} [numericFormat]
 * @property {string} [unit]
 * @property {boolean} [isDisabled=false] - Whether the variable is included in the visualization
 */
class DataImplementationOverride {
    constructor(props = {}) {
        const { DEFAULTS } = DataImplementationOverride;
        Object.assign(this, DEFAULTS, props);
    }
    hasOverrideFor(field) {
        return this[field] !== undefined && this[field] !== null;
    }
    toJSON() {
        return {
            label: this.label,
            numericFormat: this.numericFormat,
            unit: this.unit,
            isDisabled: this.isDisabled,
        };
    }
    static get DEFAULTS() {
        return {
            label: null,
            numericFormat: null,
            unit: null,
            isDisabled: false,
        };
    }
}
export default DataImplementationOverride;
